import * as React from 'react';
import { Upload, Icon, message, Modal } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import FlexApiService, { IBucketInfo, CreateBucketParam, defaultBucketParam } from 'src/services/FlexApiService';
import uuid from 'uuid';
import { getBase64, imgCheckError, createImgName } from 'src/utils/upload';
interface IUpLoadImgProps {
  onChange?: (value: string | undefined) => void;
  value?: string;
  bucketInfo: IBucketInfo | undefined,
}

interface IUpLoadImgState {
  previewVisible: boolean;
  previewImage: string | undefined;
  fileList: UploadFile[];
}

class UpLoadImg extends React.Component<IUpLoadImgProps, IUpLoadImgState> {
  private bucket: IBucketInfo | undefined;
  private flexService = FlexApiService;
  constructor(props: IUpLoadImgProps) {
    super(props);
    const { value, bucketInfo } = props;
    const url = value ? value : '';
    let fileList: UploadFile[] = [];
    if (url) {
      fileList = [{
        uid: uuid.v4(),
        status: 'done',
        name: url,
        url,
        preview: url,
      } as UploadFile];
    }
    this.state = {
      previewVisible: false,
      previewImage: '',
      fileList,
    }
    this.bucket = bucketInfo;
  }

  handleCancel = () => this.setState({ previewVisible: false });

  /**
   * 查看图片
   * @param file 文件
   */
  handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as Blob);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };

  /**
   * 上传文件前组件预处理 返回false 不自动上传；手动处理上传逻辑
   * @param file 上传文件
   * @returns boolean
   */
  beforeUpload = (file: File) => {
    this.uploadFile(file)
    return false;
  }

  /**
   * 上传文件
   * @param file 文件
   * @returns 
   */
  private uploadFile = async (file: File): Promise<void> => {
    try {
      if (await imgCheckError(file, 800, 800)) {
        return;
      }
      if (!!this.bucket) {
        const name = createImgName(file.type);
        const fileParam = new File([file], name);
        const res = await this.flexService.uploadJumpLinkPic(this.bucket, fileParam);
        if (!!res) {
          this.setState({
            fileList: [
              {
                uid: uuid.v4(),
                name: fileParam.name,
                status: 'done',
                url: res,
                preview: res
              } as UploadFile,
            ]
          })
          this.triggerChange(res);
        } else {
          message.error('上传照片失败了!');
        }
      } else {
        message.error('上传照片失败了!');
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * 移除
   * @param file 文件
   */
  onRemove = (file: UploadFile) => {
    this.setState(state => {
      const index = state.fileList.indexOf(file);
      const newFileList = state.fileList.slice();
      newFileList.splice(index, 1);
      return {
        fileList: newFileList,
      };
    });
    this.triggerChange('');
  }

  /**
   * 数据改变时触发
   *
   */
  triggerChange = (url: string) => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange(url)
    }
  }

  render() {
    const { previewVisible, previewImage, fileList } = this.state;
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    const notesContent = (
      <div>
        注：图片建议尺寸 宽800px，高800px
      </div>
    )
    return (
      <div className="clearfix" >
        <Upload
          listType='picture-card'
          onPreview={this.handlePreview}
          beforeUpload={this.beforeUpload}
          onRemove={this.onRemove}
          accept="image/*"
          fileList={fileList}>
          {fileList.length >= 1 ? null : uploadButton}
        </Upload>
        {notesContent}
        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}
export default UpLoadImg;


// WEBPACK FOOTER //
// ./src/components/common/UpLoadImg.tsx